// extracted by mini-css-extract-plugin
module.exports = {"cardWrapper":"card_cardWrapper__1K4nq","cardWrapperHeader":"card_cardWrapperHeader__59JQk","cardWrapperContent":"card_cardWrapperContent__3Gd-M"};